// extracted by mini-css-extract-plugin
export default {"container":"Input_container__Sorid","horizontal-label":"Input_horizontal-label__utEGg","disabled":"Input_disabled__ut16N"};